<button id='icon-button-{{ index }}' (click)='selectButton(index)' class='icon-button icon-button-color-{{icon}}' [ngClass]="getColorButtonSelectedCssAttribute()"><i class="fa" [ngClass]="getIconCssAttribute()"></i></button>
